import { useEffect } from "react";
import { MainLayout, SectionLayout } from "../layouts";
import { useLocation } from "react-router-dom";
import BannerPage from "../components/BannerPage";

const SECTIONS = [
  {
    title: "1. Informasi yang Kami Kumpulkan",
    content: `Kami dapat mengumpulkan informasi yang Anda berikan secara langsung saat menggunakan layanan kami, antara lain nama, alamat email, nomor telepon, dan data lain yang Anda isikan melalui formulir pendaftaran, kontak, atau layanan digital di lingkungan Pendidikan Pesantren Idrisiyyah Tasikmalaya. Selain itu, kami juga dapat mengumpulkan data teknis secara otomatis seperti alamat IP, jenis perangkat, dan aktivitas penjelajahan pada situs web kami untuk keperluan analitik dan peningkatan layanan.`,
  },
  {
    title: "2. Tujuan Penggunaan Informasi",
    content: `Informasi yang kami kumpulkan digunakan untuk keperluan administrasi pendidikan, komunikasi terkait kegiatan sekolah dan pesantren, penyampaian informasi akademik, publikasi berita dan kegiatan, serta peningkatan kualitas layanan situs web. Kami tidak menggunakan data pribadi Anda untuk tujuan komersial di luar konteks layanan pendidikan yang kami sediakan.`,
  },
  {
    title: "3. Perlindungan Data",
    content: `Kami menerapkan langkah-langkah teknis dan organisasi yang wajar untuk melindungi data pribadi Anda dari akses yang tidak sah, perubahan, pengungkapan, atau pemusnahan data. Meskipun demikian, tidak ada metode transmisi melalui internet atau penyimpanan elektronik yang sepenuhnya aman, sehingga kami tidak dapat menjamin keamanan mutlak atas data yang Anda kirimkan kepada kami.`,
  },
  {
    title: "4. Pembagian Informasi kepada Pihak Ketiga",
    content: `Kami tidak menjual, menyewakan, atau memperdagangkan informasi pribadi Anda kepada pihak ketiga. Informasi dapat dibagikan kepada pihak terkait hanya jika diperlukan untuk kepentingan operasional pendidikan, dipersyaratkan oleh peraturan perundang-undangan yang berlaku, atau atas persetujuan eksplisit dari Anda.`,
  },
  {
    title: "5. Cookies dan Teknologi Pelacakan",
    content: `Situs web kami dapat menggunakan cookies dan teknologi serupa untuk meningkatkan pengalaman pengguna, mengingat preferensi Anda, dan menganalisis pola penggunaan situs. Anda dapat mengatur browser Anda untuk menolak cookies, namun hal ini dapat memengaruhi fungsi tertentu pada situs web kami.`,
  },
  {
    title: "6. Hak Anda atas Data Pribadi",
    content: `Anda berhak untuk mengakses, memperbarui, atau meminta penghapusan data pribadi Anda yang kami simpan, sepanjang tidak bertentangan dengan kewajiban administratif dan hukum yang berlaku. Permintaan tersebut dapat diajukan melalui kontak resmi yang tercantum pada situs web ini.`,
  },
  {
    title: "7. Perubahan Kebijakan Privasi",
    content: `Kami dapat memperbarui Kebijakan Privasi ini dari waktu ke waktu untuk menyesuaikan dengan perkembangan layanan maupun ketentuan hukum yang berlaku. Setiap perubahan akan dipublikasikan pada halaman ini beserta tanggal pembaruan terakhir.`,
  },
  {
    title: "8. Kontak Kami",
    content: `Jika Anda memiliki pertanyaan, saran, atau keluhan terkait Kebijakan Privasi ini, silakan hubungi kami melalui kontak resmi yang tersedia pada situs web Pendidikan Pesantren Idrisiyyah Tasikmalaya.`,
  },
];

export default function KebijakanPrivasi() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [location.pathname]);

  return (
    <MainLayout title="Kebijakan Privasi - MA Idrisiyyah">
      <BannerPage
        title="Kebijakan Privasi"
        subtitle="Komitmen kami dalam melindungi data dan privasi Anda"
      />

      <SectionLayout title="Kebijakan Privasi">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white dark:bg-neutral-800 rounded-2xl shadow-sm border border-neutral-100 dark:border-neutral-700 p-8 md:p-12">
            <p className="text-neutral-500 dark:text-neutral-400 text-sm mb-8">
              Terakhir diperbarui: 22 Juli 2026
            </p>

            <p className="text-neutral-600 dark:text-neutral-300 leading-relaxed text-justify mb-10">
              Pendidikan Pesantren Idrisiyyah Tasikmalaya ("kami") berkomitmen
              untuk melindungi privasi setiap pengunjung, siswa, wali santri,
              dan pengguna situs web ini. Kebijakan Privasi ini menjelaskan
              bagaimana kami mengumpulkan, menggunakan, melindungi, dan
              mengelola informasi pribadi Anda saat menggunakan layanan kami.
            </p>

            <div className="space-y-8">
              {SECTIONS.map((section, idx) => (
                <div
                  key={idx}
                  className="pb-8 border-b border-neutral-100 dark:border-neutral-700 last:border-0 last:pb-0"
                >
                  <h2 className="text-lg font-bold text-idi-700 dark:text-idi-400 mb-3">
                    {section.title}
                  </h2>
                  <p className="text-neutral-600 dark:text-neutral-300 leading-relaxed text-justify">
                    {section.content}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </SectionLayout>
    </MainLayout>
  );
}
